import { Button, Container, Grid, Paper } from "@mui/material";
import api from "../../api/axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function UnlockAccounT() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("unlock_token");
  const navigate = useNavigate();

  const handleUnlockAccount = async () => {
    try {
      const response = await api.get(`api/v1/unlock?unlock_token=${token}`);
      toast.success(response.data.message);
      navigate("/", { replace: true });
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
      } else {
        toast.error(err.response.data.error);
      }
    }
  };
  return (
    <Container maxWidth="sm">
      <h1 align="center">Desbloquear cuenta</h1>
      <Grid
        container
        spacing={2}
        direction="column"
        justifyContent="center"
        style={{ minHeigt: "100vh" }}
      >
        <Paper elevation={2} sx={{ padding: 5 }}>
          <Button
            variant="contained"
            fullWidth
            type="submit"
            onClick={handleUnlockAccount}
          >
            Desbloquear
          </Button>
        </Paper>
      </Grid>
    </Container>
  );
}
